/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemExpandable } from "./d-theme-white-menu-item-expandable";

export class DThemeWhiteMenuSidedItemExpandable extends DThemeWhiteMenuItemExpandable {}
